import React, { useEffect, useState } from 'react'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import { routeList } from '../../globalData/constant';
import Logo from "../../assets/images/pixl_logo_black 1.png"
import OVDicon from "../../assets/images/OVD_icon.svg"
import { useStoreValues } from '../../Context/storeProvider';

function SideBar({ isToggled, toggleStat, sideBarComponent = '' }) {
  const [IsActive, setIsActive] = useState(false)
  const { pathname } = useLocation()
  const { setUploadSide, user_Roll } = useStoreValues()
  console.log(sideBarComponent)

  const sidebarIcon = (key) => {
    switch (key) {
      case 'Document Reader': return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
          <path d="M7.56401 20V25.3333H12.8973V28H4.89734V20H7.56401ZM28.8973 20V28H20.8973V25.3333H26.2307V20H28.8973ZM18.2293 8L24.096 22.6667H21.2227L19.6213 18.6667H14.168L12.5693 22.6667H9.69734L15.5627 8H18.2293ZM16.896 11.8467L15.2333 16H18.556L16.896 11.8467ZM12.8973 4V6.66667H7.56401V12H4.89734V4H12.8973ZM28.8973 4V12H26.2307V6.66667H20.8973V4H28.8973Z" fill="#1A82E2" />
        </svg>
      )

      case 'Document Masking': return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
          <g clip-path="url(#clip0_117_407)">
            <path d="M13.35 2.45445C15.9097 3.67355 18.0714 5.59309 19.5846 7.99058C21.0979 10.3881 21.9007 13.1653 21.9 16.0004C21.9007 18.8356 21.0979 21.6128 19.5846 24.0103C18.0714 26.4078 15.9097 28.3273 13.35 29.5464C15.4205 30.087 17.5873 30.1457 19.6839 29.7181C21.7806 29.2905 23.7513 28.388 25.4448 27.0799C27.1382 25.7718 28.5092 24.0929 29.4526 22.1723C30.3959 20.2516 30.8864 18.1403 30.8864 16.0004C30.8864 13.8606 30.3959 11.7493 29.4526 9.82861C28.5092 7.90795 27.1382 6.22908 25.4448 4.92098C23.7513 3.61288 21.7806 2.71038 19.6839 2.28279C17.5873 1.85521 15.4205 1.91393 13.35 2.45445ZM9.27404 1.93245C13.0054 -0.0903599 17.3874 -0.548052 21.4562 0.660057C25.525 1.86817 28.9472 4.64312 30.97 8.37445C32.9929 12.1058 33.4505 16.4878 32.2424 20.5566C31.0343 24.6254 28.2594 28.0476 24.528 30.0704C20.7962 32.0935 16.4135 32.5513 12.3442 31.343C8.2748 30.1347 4.85211 27.3593 2.82904 23.6274C0.805972 19.8956 0.348236 15.5129 1.55653 11.4436C2.76483 7.37421 5.54018 3.95152 9.27204 1.92845L9.27404 1.93245Z" fill="#1A82E2" />
          </g>
          <defs>
            <clipPath id="clip0_117_407">
              <rect width="32" height="32" fill="white" transform="translate(0.900024)" />
            </clipPath>
          </defs>
        </svg>)

      case 'Document Verification': return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
          <path d="M23.0333 14.5066L21.14 12.6133L15.4867 18.2799L12.66 15.4399L10.7667 17.3333L15.4867 22.0533L23.0333 14.5066Z" fill="#1A82E2" />
          <path d="M4.90002 5.33301V26.6663H28.9V5.33301H4.90002ZM26.2334 23.9997H7.56669V10.6663H26.2334V23.9997Z" fill="#1A82E2" />
        </svg>)
      case 'Resume Parser': return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="40" viewBox="0 0 33 40" fill="none">
          <rect x="1.40002" y="0.5" width="31" height="39" rx="3.5" fill="white" stroke="#1A82E2" />
          <path d="M7.90002 7.14258H23.7572" stroke="#1A82E2" stroke-width="3" stroke-linecap="round" />
          <path d="M7.90002 16.2861H23.7572" stroke="#1A82E2" stroke-width="3" stroke-linecap="round" />
          <path d="M7.90002 25.4287H23.7572" stroke="#1A82E2" stroke-width="3" stroke-linecap="round" />
          <path d="M7.90002 34.5713H17.4715" stroke="#1A82E2" stroke-width="3" stroke-linecap="round" />
        </svg>
      )
      case 'OVD Classification': return (
        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="11.1363" y="3.63651" width="9.74189" height="5.18336" stroke="#1A82E2" stroke-width="0.909732" />
          <rect x="5.17862" y="12.2122" width="5.04795" height="5.18336" stroke="#1A82E2" stroke-width="0.909732" />
          <rect x="21.7879" y="12.2122" width="5.13822" height="5.18336" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="10.4106" y1="14.7776" x2="21.5136" y2="14.7776" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="2.82812" y1="20.4192" x2="12.1709" y2="20.4192" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="19.979" y1="20.3742" x2="29.3217" y2="20.3742" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="16.101" y1="8.59766" x2="16.101" y2="14.6907" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="7.66104" y1="17.7148" x2="7.66104" y2="20.8291" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="3.28299" y1="20.1973" x2="3.28299" y2="23.3115" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="11.7232" y1="20.0615" x2="11.7232" y2="23.1758" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="20.2985" y1="19.8813" x2="20.2985" y2="22.9956" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="28.9191" y1="19.9712" x2="28.9191" y2="23.0854" stroke="#1A82E2" stroke-width="0.909732" />
          <line x1="24.2703" y1="17.7148" x2="24.2703" y2="20.8291" stroke="#1A82E2" stroke-width="0.909732" />
          <circle cx="3.2569" cy="25.636" r="2.72708" stroke="#1A82E2" stroke-width="0.909732" />
          <circle cx="11.8323" cy="25.636" r="2.72708" stroke="#1A82E2" stroke-width="0.909732" />
          <circle cx="20.3627" cy="25.636" r="2.72708" stroke="#1A82E2" stroke-width="0.909732" />
          <circle cx="28.893" cy="25.636" r="2.72708" stroke="#1A82E2" stroke-width="0.909732" />
        </svg>
      )
    }
  }

 const sideBarMenu = (UserRole) =>{
  switch (UserRole) {
    case "Admin":
      return(
          <>
            <MenuItem
              active={pathname == "/admin/clientlist"}
              component={<Link to={"/admin/clientlist"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Accounts"}
            </MenuItem>
            {/* <MenuItem
              active={pathname == "/admin/client_admin_list"}
              component={<Link to={"/admin/client_admin_list"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Accounts"}
            </MenuItem> */}
            <MenuItem
              active={pathname == "/admin/hit-services"}
              component={<Link to={"/admin/hit-services"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Services"}
            </MenuItem>
            {/* <MenuItem
              active={pathname == "/admin/hit-deploymentserver"}
              component={<Link to={"/admin/hit-deploymentserver"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Deployment Server"}
            </MenuItem> */}
            </>
      )
    case "AdminClient":
      return(
          <>
            <MenuItem
              active={pathname == "/admin/clientlist"}
              component={<Link to={"/admin/clientlist"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Accounts"}
            </MenuItem>
            {/* <MenuItem
              active={pathname == "/admin/hit-services"}
              component={<Link to={"/admin/hit-services"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Services"}
            </MenuItem> */}
            {/* <MenuItem
              active={pathname == "/admin/hit-deploymentserver"}
              component={<Link to={"/admin/hit-deploymentserver"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Deployment Server"}
            </MenuItem> */}
            </>
      )
  
    default:
      break;
  }
 }

  return (
    <div className='bg_gray5'>
      <Sidebar toggled={isToggled} breakPoint="all" style={{ zIndex: 1 }}>
        <img src={Logo} className="logo mb-3 pt-3 ps-3 d-none" />
        <div className="d-flex w-100 justify-content-between px-3 py_10x sidebar_title bd_gray2 border-bottom mt-0">
          <div className="d-flex align-items-center text_master2">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="31" viewBox="0 0 26 31" fill="none">
              <path d="M13 0.875L26 7.375V23.625L13 30.1094L0 23.625V7.375L13 0.875ZM22.7656 8L13 3.125L9.23438 5L18.9375 9.90625L22.7656 8ZM13 12.875L16.7188 11.0312L7 6.125L3.23438 8L13 12.875ZM2 9.625V22.375L12 27.375V14.625L2 9.625ZM14 27.375L24 22.375V9.625L14 14.625V27.375Z" fill="#1A82E2" /></svg>
            <span className="ps-2 text-uppercase font_14 fw-bold ws_nowrp">Our Products</span>
          </div>
          <div className="bg_light2 cursor-pointer d-lg-none d-flex ms-3 round_sm rounded-circle text_master2" onClick={toggleStat}>
            <i className="fas fa-angle-left m-auto"></i>
          </div>
        </div>
        <Menu


          menuItemStyles={{
            button: {
              // the active class will be added automatically by react router
              // so we can use it to style the active menu item
              [`&.active`]: {
                backgroundColor: 'red',
                color: '#b6c8d9',
              },
            },
          }}

        >



          {Object.entries(sideBarComponent).map(([key, value], index) => {
            if (key == "API Logs") {
              return
            }
            if (Array.isArray(value) && value.length > 0) {
              // ""
              //console.log(key);
              return (
                <SubMenu key={index} icon={sidebarIcon(key)} label={key} defaultOpen={
                  sideBarComponent[key].some((itm) => { pathname.includes(itm.path) })
                }
                >
                  {value.map((itm, subIndex) =>
                  // //console.log(pathname.includes(itm.path), pathname, itm.path,sideBarComponent) ||
                  (
                    <MenuItem


                      key={subIndex}
                      active={pathname.includes(itm.path) || itm.sideMenuName == "User List" && pathname == "/admin/user-details"}
                      component={<Link to={itm.path} />}
                      // icon={<i className={itm.icon}></i>}
                      className={``}
                      onClick={() => { setUploadSide(true) }}
                    >
                      {itm.sideMenuName}
                    </MenuItem>
                  ))}
                </SubMenu>
              );
            }
            return null;
          })}

          {sideBarMenu(user_Roll)}
          <SubMenu label={'Logs'}>
            <MenuItem
              active={pathname == "/api-logs"}
              component={<Link to={"/api-logs"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Verification Logs"}
            </MenuItem>
            <MenuItem
              active={pathname == "/service-logs"}
              component={<Link to={"/service-logs"} />}
              // icon={<i className={itm.icon}></i>}
              className={`text-capitalize`}
            // onClick={() => { setUploadSide(true) }}
            >
              {"Service Logs"}
            </MenuItem>
          </SubMenu>
         

        </Menu>
      </Sidebar>
    </div>
  )
}

export default SideBar
